import { Helmet } from 'react-helmet-async';
import { Footer } from '../Components/Footer';
import clsx from 'clsx';
import React from 'react';
import { UseIsMobile } from 'common/hooks/UseIsMobile';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

interface LayoutType {
    children: React.ReactNode;
    title?: any;
    strech?: boolean;
}

export const Layout = ({ children, strech, title }: LayoutType) => {

    const isMobile = UseIsMobile();

    const { t } = useTranslation()

    const [searchParams] = useSearchParams();

    const productType = searchParams.get('pt')?.toLowerCase()


    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <div
                className={`max-h-screen min-h-screen w-full bg-gradient-to-b from-[#144C84] to-[#0A1622] overflow-x-hidden`}
            // style={{ backgroundImage: `url(/assets/images/${pathName})` }}
            >
                {isMobile ? null : (
                    <div className="flex flex-col gap-y-4 xl:gap-y-8 mt-6 xl:mt-12 max-w-[1900px] w-full select-none">

                        <div className='flex md:flex-col xl:flex-row justify-center items-center gap-4'>
                            <div className="flex grow gap-6 justify-center content-center w-3/5">
                                <div
                                    className={clsx(
                                        'bg-L-basic min-w-[450px] max-w-[450px] xl:min-w-[514px] xl:max-w-[514px] rounded-3xl shadow-md relative',
                                        {
                                            'max-w-[480px]': !!strech,
                                        }
                                    )}
                                >
                                    <div
                                        className={clsx('px-10  xl:px-[72px] xl:py-4')}
                                    >
                                        {children}
                                    </div>
                                </div>
                            </div>
                            {
                                !productType?.toLowerCase().includes('kahkeshan') && (
                                    <div className="md:flex grow hidden justify-center bg-cover w-2/5 xl:pl-[10%]"
                                    >
                                        <div className='flex flex-col gap-y-4 justify-between'>

                                            <div className="w-[514px] h-full p-10 text-white mx-auto relative"
                                            >
                                                <div
                                                    className='absolute [1px] h-[1px] rounded-full left-1/2 top-1/2 bg-transparent shadow-[0_0_250px_250px_rgba(153,81,218,0.5)]'
                                                ></div>

                                                <div
                                                    className='absolute w-[110%] h-[125%] right-2 top-4 bg-cover bg-Hobab'
                                                ></div>

                                                <div className='text-center relative'>
                                                    <h2 className='text-5xl'>{t("kahkeshan.title")}</h2>
                                                    <p className='mt-2 text-3xl'>{t("kahkeshan.SubTitle")}</p>
                                                    <p className='mt-12 mb-16 text-justify'>
                                                        {t("kahkeshan.caption")}
                                                    </p>
                                                    <button
                                                        className='w-full bg-gradient-to-l from-[#9A51DA] from to-[#653FEC] text-white text-3xl rounded-lg p-3'>
                                                        <a className='w-full h-full inline-block'
                                                            href={window.api.KAHKESHAN_URL || "#"} target='_blank'
                                                            rel="noreferrer">
                                                            {t("kahkeshan.goToKahkeshan")}
                                                        </a>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )
                            }
                        </div>

                        <div className="px-14 py-3">
                            <div className="w-full pt-4 m-auto hidden md:block text-white">
                                <Footer />
                            </div>
                        </div>

                    </div>
                )}
            </div>
        </>
    );
};

export default Layout;
